import updateSingleDatasetInView from './updateSingleDatasetInView';
export default function updateMultipleDatasetsInView(view, data) {
  Object.keys(data).forEach(function (name) {
    updateSingleDatasetInView(view, name, data[name]);
  });
}